export const typeResponsibility = {
  OWNER: 'PROPRIETÁRIO',
  TENANT: 'INQUILINO',
};

export const typeStatus = {
  CONFIRMED: 1,
  CHANGED_RESPONSIBILITY: 2,
  AWATING: 3,
  HIRED: 4,
  DONE: 5,
};

export const steps = [
  {
    b2b_status_id: 1,
    text: 'Pedido confirmado',
  },
  {
    b2b_status_id: 3,
    text: 'Aguardando contratação',
  },
  {
    b2b_status_id: 4,
    text: 'Profissional contratado',
  },
  {
    b2b_status_id: 5,
    text: 'Serviço realizado',
  },
];

export const textStatus = (statusIndex, quotes = 0) => {
  const status = ([
    {
      b2b_status_id: 0,
      yourResponsibility: { },
      noResponsibility: { },
    },
    {
      b2b_status_id: 1,
      yourResponsibility: {
        description: 'Pedido confirmado',
        help: 'Seu pedido foi confirmado! Nosso time está analisando os detalhes do seu pedido e em breve você começará a receber os orçamentos de profissionais verificados.',
        titleQuotes: `Orçamentos recebidos (${quotes})`,
      },
      noResponsibility: {
        description: 'Pedido confirmado',
        help: 'Seu pedido foi confirmado! Nosso time está analisando os detalhes do seu pedido e em breve você começará a receber os orçamentos de profissionais verificados.',
        titleQuotes: `Orçamentos recebidos (${quotes})`,
      },
    },
    {
      b2b_status_id: 3,
      yourResponsibility: {
        description: 'Aguardando aprovação do proprietário',
        help: 'Não esqueça de responder os profisisonais no chat para que eles possam entender melhor seu problema! Não se preocupe, os orçamentos serão enviados direto para o proprietário(a) do imóvel.',
        titleQuotes: `Orçamentos recebidos (${quotes})`,
      },
      noResponsibility: {
        description: 'Aguardando contratação',
        help: 'Não esqueça de conversar com os profisisonais pelo chat para que eles possam enviar um orçamento mais preciso. Quando escolher um profissional é só contratá-lo por aqui mesmo!',
        titleQuotes: `Orçamentos recebidos (${quotes})`,
      },
    },
    {
      b2b_status_id: 4,
      yourResponsibility: {
        description: 'Profissional contratado',
        help: 'Ótimo! Agora que você já contratou um profissional, não esqueça de combinar com ele pelo chat o melhor dia e horário para a realização do serviço.',
        titleQuotes: 'Profissional contratado',
      },
      noResponsibility: {
        description: 'Profissional contratado',
        help: 'Boas notícias! O proprietário(a) do imóvel já contratou um profissional. Agora não esqueça de combinar com ele pelo chat o melhor dia e horário para a realização do serviço.',
        titleQuotes: 'Profissional contratado',
      },
    },
    {
      b2b_status_id: 5,
      yourResponsibility: {
        description: 'Serviço realizado',
        help: 'Problema resolvido! Deu tudo certo com o serviço? Não esqueça de avaliar o profissional que te atendeu e se tiver algum problema pode contar com nossa central de ajuda! ',
        titleQuotes: 'Profissional contratado',
      },
      noResponsibility: {
        description: 'Serviço realizado',
        help: 'Problema resolvido! Deu tudo certo com o serviço? Não esqueça de avaliar o profissional que te atendeu e se tiver algum problema pode contar com nossa central de ajuda! ',
        titleQuotes: 'Profissional contratado',
      },
    },
  ]);
  return status.find(value => (value.b2b_status_id === statusIndex)) || status[0];
};
